<app-modal-top-notch class="top-notch" [ngStyle]="{'top': notchTopPosition, 'left': notchLeftPosition}"></app-modal-top-notch>
<div class="container">
    <div class="title-block">
        <h4>PARTNER SPLITS</h4>
    </div>
    <div class="partner-splits-block">
        <div *ngFor="let member of partnerGroup.members" class="partner-split-row">
            <span class="member-name">{{member.partner.name}}:</span>
            <span>{{member.allocationPercentage}}</span>
            <span *ngIf="member.postDilution">Post Dilution</span>
        </div>

    </div>
    <div class="action-block">
        <button class="edit-btn" (click)="navigateToPartnerGroup()">Edit</button>
    </div>

</div>